// extracted by mini-css-extract-plugin
export var createdDate = "_mt-1";
export var divider = "_mt-2";
export var headerDivider = "_mt-3";
export var messagesCard = "_mt-0";
export var messagesContainer = "_mt-7";
export var messagesContainerWrapper = "_mt-4";
export var pointerCapturingButtonBoxes = "_mt-a";
export var showLeftPanelButton = "_mt-9";
export var showMoreButton = "_mt-c";
export var showMoreButtonContainer = "_mt-b";
export var summaryTitle = "_mt-6";
export var systemMessageCardWrapper = "_mt-d";
export var topButtons = "_mt-8";
export var withPadding = "_mt-5";